@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.map.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.map.resources/"

@delegate:ResourceContentHash(-1_851_754_604)
internal val Res.string.map_search_trees_header: StringResource by lazy {
      StringResource("string:map_search_trees_header", "map_search_trees_header", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7689, 39),
      ))
    }

@delegate:ResourceContentHash(-1_184_181_251)
internal val Res.string.map_seasonal_chip_description_with_count_plural: StringResource by lazy {
      StringResource("string:map_seasonal_chip_description_with_count_plural", "map_seasonal_chip_description_with_count_plural", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7729, 111),
      ))
    }

@delegate:ResourceContentHash(20_496_444)
internal val Res.string.map_seasonal_chip_description_with_count_singular: StringResource by lazy {
      StringResource("string:map_seasonal_chip_description_with_count_singular", "map_seasonal_chip_description_with_count_singular", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7841, 113),
      ))
    }

@delegate:ResourceContentHash(-562_862_428)
internal val Res.string.map_seasonal_chip_description_without_count: StringResource by lazy {
      StringResource("string:map_seasonal_chip_description_without_count", "map_seasonal_chip_description_without_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7955, 59),
      ))
    }

@delegate:ResourceContentHash(-725_192_534)
internal val Res.string.map_seasonal_chip_with_count: StringResource by lazy {
      StringResource("string:map_seasonal_chip_with_count", "map_seasonal_chip_with_count", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8015, 52),
      ))
    }

@delegate:ResourceContentHash(1_367_288_911)
internal val Res.string.map_seasonal_next_heading: StringResource by lazy {
      StringResource("string:map_seasonal_next_heading", "map_seasonal_next_heading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8068, 53),
      ))
    }

@delegate:ResourceContentHash(1_799_054_083)
internal val Res.string.map_seasonal_subtitle_local: StringResource by lazy {
      StringResource("string:map_seasonal_subtitle_local", "map_seasonal_subtitle_local", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8122, 67),
      ))
    }

@delegate:ResourceContentHash(-2_124_922_065)
internal val Res.string.map_seasonal_subtitle_national: StringResource by lazy {
      StringResource("string:map_seasonal_subtitle_national", "map_seasonal_subtitle_national", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8190, 62),
      ))
    }

@delegate:ResourceContentHash(-1_832_006_763)
internal val Res.string.map_selected_close_description: StringResource by lazy {
      StringResource("string:map_selected_close_description", "map_selected_close_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8253, 58),
      ))
    }

@delegate:ResourceContentHash(1_563_756_191)
internal val Res.string.map_selected_directions: StringResource by lazy {
      StringResource("string:map_selected_directions", "map_selected_directions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8312, 43),
      ))
    }

@delegate:ResourceContentHash(-2_005_705_527)
internal val Res.string.map_selected_meta_distance: StringResource by lazy {
      StringResource("string:map_selected_meta_distance", "map_selected_meta_distance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8423, 46),
      ))
    }

@delegate:ResourceContentHash(340_426_262)
internal val Res.string.map_selected_meta_distance_unknown: StringResource by lazy {
      StringResource("string:map_selected_meta_distance_unknown", "map_selected_meta_distance_unknown", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8356, 66),
      ))
    }

@delegate:ResourceContentHash(-725_192_519)
internal val Res.string.map_selected_meta_with_season: StringResource by lazy {
      StringResource("string:map_selected_meta_with_season", "map_selected_meta_with_season", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8470, 53),
      ))
    }

@delegate:ResourceContentHash(-1_624_967_384)
internal val Res.string.map_selected_start_harvest: StringResource by lazy {
      StringResource("string:map_selected_start_harvest", "map_selected_start_harvest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8524, 62),
      ))
    }

@delegate:ResourceContentHash(-667_310_243)
internal val Res.string.map_site_created: StringResource by lazy {
      StringResource("string:map_site_created", "map_site_created", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8587, 56),
      ))
    }

@delegate:ResourceContentHash(-2_005_705_527)
internal val Res.string.map_site_distance: StringResource by lazy {
      StringResource("string:map_site_distance", "map_site_distance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8644, 37),
      ))
    }

@delegate:ResourceContentHash(687_023_585)
internal val Res.string.map_site_legend_ask: StringResource by lazy {
      StringResource("string:map_site_legend_ask", "map_site_legend_ask", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8682, 79),
      ))
    }

@delegate:ResourceContentHash(154_069_388)
internal val Res.string.map_site_legend_detail: StringResource by lazy {
      StringResource("string:map_site_legend_detail", "map_site_legend_detail", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8762, 134),
      ))
    }

@delegate:ResourceContentHash(-1_697_308_689)
internal val Res.string.map_site_legend_harvest: StringResource by lazy {
      StringResource("string:map_site_legend_harvest", "map_site_legend_harvest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8897, 119),
      ))
    }

@delegate:ResourceContentHash(1_609_630_841)
internal val Res.string.map_site_legend_open: StringResource by lazy {
      StringResource("string:map_site_legend_open", "map_site_legend_open", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9017, 56),
      ))
    }

@delegate:ResourceContentHash(1_938_641_899)
internal val Res.string.map_site_legend_private: StringResource by lazy {
      StringResource("string:map_site_legend_private", "map_site_legend_private", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9074, 103),
      ))
    }

@delegate:ResourceContentHash(-2_144_779_811)
internal val Res.string.map_site_legend_title: StringResource by lazy {
      StringResource("string:map_site_legend_title", "map_site_legend_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9178, 37),
      ))
    }

@delegate:ResourceContentHash(-2_115_672_232)
internal val Res.string.map_site_open_description: StringResource by lazy {
      StringResource("string:map_site_open_description", "map_site_open_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9216, 73),
      ))
    }

@delegate:ResourceContentHash(-1_657_909_573)
internal val Res.string.map_site_plaque_label: StringResource by lazy {
      StringResource("string:map_site_plaque_label", "map_site_plaque_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9290, 41),
      ))
    }

@delegate:ResourceContentHash(485_117_965)
internal val Res.string.map_site_removed: StringResource by lazy {
      StringResource("string:map_site_removed", "map_site_removed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9332, 60),
      ))
    }

@delegate:ResourceContentHash(-1_654_442_654)
internal val Res.string.map_site_rule_ask: StringResource by lazy {
      StringResource("string:map_site_rule_ask", "map_site_rule_ask", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9393, 45),
      ))
    }

@delegate:ResourceContentHash(1_926_811_893)
internal val Res.string.map_site_rule_open: StringResource by lazy {
      StringResource("string:map_site_rule_open", "map_site_rule_open", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9439, 42),
      ))
    }

@delegate:ResourceContentHash(512_460_700)
internal val Res.string.map_site_rule_private: StringResource by lazy {
      StringResource("string:map_site_rule_private", "map_site_rule_private", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9552, 61),
      ))
    }

@delegate:ResourceContentHash(120_836_632)
internal val Res.string.map_site_rule_private_harvest: StringResource by lazy {
      StringResource("string:map_site_rule_private_harvest", "map_site_rule_private_harvest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9482, 69),
      ))
    }

@delegate:ResourceContentHash(1_637_290_674)
internal val Res.string.map_site_species_none: StringResource by lazy {
      StringResource("string:map_site_species_none", "map_site_species_none", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9614, 61),
      ))
    }

@delegate:ResourceContentHash(75_892_734)
internal val Res.string.map_site_species_two: StringResource by lazy {
      StringResource("string:map_site_species_two", "map_site_species_two", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9676, 44),
      ))
    }

@delegate:ResourceContentHash(-1_337_755_182)
internal val Res.string.map_site_summary: StringResource by lazy {
      StringResource("string:map_site_summary", "map_site_summary", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9774, 52),
      ))
    }

@delegate:ResourceContentHash(-725_192_519)
internal val Res.string.map_site_summary_no_distance: StringResource by lazy {
      StringResource("string:map_site_summary_no_distance", "map_site_summary_no_distance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9721, 52),
      ))
    }

@delegate:ResourceContentHash(1_326_542_444)
internal val Res.string.map_site_tree_locked_label: StringResource by lazy {
      StringResource("string:map_site_tree_locked_label", "map_site_tree_locked_label", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9827, 62),
      ))
    }

@delegate:ResourceContentHash(942_067_932)
internal val Res.string.map_stale_cache: StringResource by lazy {
      StringResource("string:map_stale_cache", "map_stale_cache", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9890, 79),
      ))
    }

@delegate:ResourceContentHash(1_656_911_565)
internal val Res.string.map_truncated_batch: StringResource by lazy {
      StringResource("string:map_truncated_batch", "map_truncated_batch", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9970, 99),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("map_search_trees_header", Res.string.map_search_trees_header)
  map.put("map_seasonal_chip_description_with_count_plural", Res.string.map_seasonal_chip_description_with_count_plural)
  map.put("map_seasonal_chip_description_with_count_singular", Res.string.map_seasonal_chip_description_with_count_singular)
  map.put("map_seasonal_chip_description_without_count", Res.string.map_seasonal_chip_description_without_count)
  map.put("map_seasonal_chip_with_count", Res.string.map_seasonal_chip_with_count)
  map.put("map_seasonal_next_heading", Res.string.map_seasonal_next_heading)
  map.put("map_seasonal_subtitle_local", Res.string.map_seasonal_subtitle_local)
  map.put("map_seasonal_subtitle_national", Res.string.map_seasonal_subtitle_national)
  map.put("map_selected_close_description", Res.string.map_selected_close_description)
  map.put("map_selected_directions", Res.string.map_selected_directions)
  map.put("map_selected_meta_distance", Res.string.map_selected_meta_distance)
  map.put("map_selected_meta_distance_unknown", Res.string.map_selected_meta_distance_unknown)
  map.put("map_selected_meta_with_season", Res.string.map_selected_meta_with_season)
  map.put("map_selected_start_harvest", Res.string.map_selected_start_harvest)
  map.put("map_site_created", Res.string.map_site_created)
  map.put("map_site_distance", Res.string.map_site_distance)
  map.put("map_site_legend_ask", Res.string.map_site_legend_ask)
  map.put("map_site_legend_detail", Res.string.map_site_legend_detail)
  map.put("map_site_legend_harvest", Res.string.map_site_legend_harvest)
  map.put("map_site_legend_open", Res.string.map_site_legend_open)
  map.put("map_site_legend_private", Res.string.map_site_legend_private)
  map.put("map_site_legend_title", Res.string.map_site_legend_title)
  map.put("map_site_open_description", Res.string.map_site_open_description)
  map.put("map_site_plaque_label", Res.string.map_site_plaque_label)
  map.put("map_site_removed", Res.string.map_site_removed)
  map.put("map_site_rule_ask", Res.string.map_site_rule_ask)
  map.put("map_site_rule_open", Res.string.map_site_rule_open)
  map.put("map_site_rule_private", Res.string.map_site_rule_private)
  map.put("map_site_rule_private_harvest", Res.string.map_site_rule_private_harvest)
  map.put("map_site_species_none", Res.string.map_site_species_none)
  map.put("map_site_species_two", Res.string.map_site_species_two)
  map.put("map_site_summary", Res.string.map_site_summary)
  map.put("map_site_summary_no_distance", Res.string.map_site_summary_no_distance)
  map.put("map_site_tree_locked_label", Res.string.map_site_tree_locked_label)
  map.put("map_stale_cache", Res.string.map_stale_cache)
  map.put("map_truncated_batch", Res.string.map_truncated_batch)
}
